import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '@/api/auth';
import { getStoredToken } from '@/auth/localToken';
import { msalEnabled } from '@/auth/AuthProvider';

export function useProfile(enabled = true) {
  const hasLocalToken = Boolean(getStoredToken());
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: fetchMe,
    enabled: enabled && (msalEnabled || hasLocalToken),
    retry: false,
  });
}
